import UserAndUserGroupManageComponent, { UserAndUserGroupManagePropsType } from './UserAndUserGroupManageComponent';

const CustomComponent = (props: any) => {
    const { userGroupId, closeModal } = props;
    const apiId = 'userGroupArea';
    //表头
    const columnsHead = [
        {
            title: '用户组',
            dataIndex: 'userGroup',
            render: (text: any) => (typeof text !== "undefined" && text !== null ?
                text.userGroupName :
                '')
        },
        {
            title: '地区',
            dataIndex: 'area',
            render: (text: any) => (typeof text !== "undefined" && text !== null ?
                text.areaName :
                '')
        }
    ];
    let extendProps: UserAndUserGroupManagePropsType = {
        mode: 'userGroup',
        titleName: '用户组地区管理',
        apiId,
        userOrUserGroupId: userGroupId,
        columnsHead,
        closeModal
    }

    return (
        <>
            <UserAndUserGroupManageComponent extendData={extendProps} ></UserAndUserGroupManageComponent>
        </>
    )
}

export default CustomComponent;